module.exports = __webpack_public_path__ + "static/media/Softech-min.94f08330.webp";